/**
 * Created by iamso on 08.07.2021
 */

const InviteIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.invite_icon_json,
        priority: SideBar.PRIORITY_REDUNDANT
    });
};

InviteIcon.prototype = Object.create(SideBarIcon.prototype);
InviteIcon.prototype.constructor = InviteIcon;

InviteIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "InviteIcon",
        keepControls: true,
        action: function (f) {
            if (connector.platform.listShareChannels().length === 0) {
                f();
                return;
            }

            if (this.attention) {
                cleverapps.dataLoader.save(DataLoader.TYPES.INVITE_ICON, { shown: true });

                cleverapps.sideBar.resetByClassName(InviteIcon);
            }

            cleverapps.SocialManager.inviteFriends("default", (success) => {
                if (success) {
                    cleverapps.metrics.logEvent(cleverapps.EVENTS.INVITE_ICON_SHARE);
                }
                f();
            });
        }.bind(this)
    });
};

InviteIcon.prototype.resetState = function () {
    const hidedByLocation = cleverapps.config.type !== "merge" && typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation;

    // yields to InviteFriendsIcon whenever that feature is up and the platform can actually count joined friends
    const supersededByInviteFriends = Boolean(cleverapps.inviteFriends) && cleverapps.inviteFriends.isAvailable();

    this.available = levels.user.checkAvailable(cleverapps.config.availables.INVITE_FRIENDS_ICON)
        && connector.platform.listShareChannels().length > 0 && !hidedByLocation && !supersededByInviteFriends;

    this.setTitle(Messages.get("InviteIcon.Title"));

    const data = cleverapps.dataLoader.load(DataLoader.TYPES.INVITE_ICON) || {};
    this.setAttention(!data.shown);
};
